import { rangeDateValueLabel } from '~/components/AiSearchChips/DateRangeChip/DateRangeChip.utils';
import { currentValue } from '~/components/AiSearchChips/StringMatchChip/StringMatchChip.utils';
const soleFieldKey = (arm)=>{
    const keys = Object.entries(arm).filter((param)=>{
        let [, value] = param;
        return value != null;
    }).map((param)=>{
        let [key] = param;
        return key;
    });
    return keys.length === 1 ? keys[0] : null;
};
const isExactDate = (predicate)=>predicate != null && 'eq' in predicate && predicate.eq != null && predicate.gte == null && predicate.lte == null && predicate.neq == null;
const soleCollapsibleField = (editors, arms)=>{
    var _Object_keys_find;
    const keys = arms.map(soleFieldKey);
    const shared = keys[0];
    if (shared == null || !keys.every((key)=>key === shared)) return null;
    return (_Object_keys_find = Object.keys(editors).find((field)=>field === shared)) !== null && _Object_keys_find !== void 0 ? _Object_keys_find : null;
};
export const collapsibleValueGroup = (editors, arms)=>{
    if (arms.length < 2) return null;
    const field = soleCollapsibleField(editors, arms);
    if (field == null) return null;
    const present = arms.map((arm)=>arm[field]).filter((predicate)=>predicate != null);
    if (present.length !== arms.length) return null;
    if (editors[field] === 'date') {
        const dates = present.filter(isExactDate);
        return dates.length === arms.length ? {
            kind: 'date',
            field,
            predicates: dates
        } : null;
    }
    if (editors[field] !== 'text') return null;
    // WHY: the entity's own grammar declares which predicate shape a field carries; TS cannot narrow the leaf union from the descriptor.
    return {
        kind: 'string',
        field,
        predicates: present
    };
};
export const collapsedValueGroupValues = (group)=>group.kind === 'string' ? group.predicates.map((predicate)=>{
        const value = currentValue(predicate);
        return {
            label: value,
            value
        };
    }) : group.predicates.map((predicate)=>({
            label: rangeDateValueLabel(predicate, predicate.eq),
            value: predicate.eq
        }));
